import { BrutusCaseRunDetailReadModel, BrutusJobResult, BrutusReference, SystemFrequencies, BrutusTestType, BrutusCaseRunRelation, BrutusJobGender, SampleSex, LabReportsTextsType, BrutusGender } from "@app/api2/api";
import { copyWithStyle } from "@app/components/CopyToClipboard";
import { BPBoxWithHeader } from "@app/components/React/Common/BPBoxWithHeader";
import { yesNo, toDate, toSci } from "@app/components/React/Common/Utils";
import { useDebounce } from "@react-hook/debounce";
import { uniqBy } from "lodash";
import { nanoid } from "nanoid";
import React from "react";
import { Grid, GridRow, GridColumn, Button, TableCell, TableHeader, TableRow, TableHeaderCell, TableBody, TableFooter } from "@/components/bp/bp-ui";
import { NoteTemplates } from "../../../NoteTemplates";
import { GenderSelectorSelect } from "../../../RunTypes/Brutus/GenderSelector";
import { PedigreeGraph } from "../../../RunTypes/Brutus/Pedigree/Graph";
import { BPButton } from "@/components/bp/bpbutton";

interface IBrutusResultsReportProps {
    details: BrutusCaseRunDetailReadModel;
    model: BrutusJobResult;
    references: BrutusReference[]
    frequencies: SystemFrequencies[]
  }

export const BrutusResultsReport: React.FunctionComponent<IBrutusResultsReportProps> = (props) => {
    const t = window.translation;
    // const references = props.details.h1?.references ?? props.details.references
    const references = props.references
    const testedReferences = references?.filter(x => !x.isUntested)
    const brutusModel = props.details
    const isBrutusFreeform = brutusModel?.testType == BrutusTestType.Freeform;
    const isUhr = brutusModel?.testType == BrutusTestType.UHR;
    const isKinship = brutusModel?.testType == BrutusTestType.Kinship;
  
    const inputRef = React.createRef<HTMLDivElement>()
  
    const [hypDefBase64, setHypDefBase64] = useDebounce<string>(null)
    const [h1Base64, setH1Base64] = useDebounce<string>(null)
    const [h2Base64, setH2Base64] = useDebounce<string>(null)
  
    // React.useEffect(() => {
    //   if (hypDefBase64)
  
    // }, [hypDefBase64])
  
    // const [hypDefBase64, setHypDefBase64] = React.useState<string>()
    // const hypDefBase64Debounced = useDebounce<string>(hypDefBase64, 1000)
    // const [h1Base64, setH1Base64] = React.useState<string>()
    // const h1Base64Debounced = useDebounce<string>(h1Base64, 1000)
    // const [h2Base64, setH2Base64] = React.useState<string>()
    // const h2Base64Debounced = useDebounce<string>(h2Base64, 1000)
  
    // const h1defGraph = React.useRef<any>();
    // Fetch API (optional)
    // React.useEffect(() => {
    //   if (h1defGraph?.current)
    //     h1defGraph.current.onPng = null;
  
    // }, [hypDefBase64Debounced])
  
    return <Grid>
      <GridRow>
        <GridColumn width={16}>
          <BPButton floated="right" labelPosition="left" content={t.common.copyToClipboard} icon={'copy'} compact onClick={() => {
            copyWithStyle(inputRef.current);
          }}></BPButton>
          <div className="brutus-report" ref={inputRef}>
            <h3>{t.brutus.pedigreeDefined}</h3>
  
            <table className="brutus center">
              <thead>
                <tr>
                  <th>{t.brutus.sex}</th>
                  <th>{t.common.reference}</th>
                  <th>{t.brutus.dnaProfileAvailable}</th>
                  <th>{t.brutus.dnaProfileUploadDate}</th>
                  <th>{t.brutus.progeny}</th>
                  <th>{t.brutus.certaintyOfRelation}</th>
                </tr>
              </thead>
              <tbody>
                {props.references?.map((curRef, idx) => {
                  const rels = (props.details?.relations ?? props.details?.h1?.relations)?.filter(x => x.ancestorId == curRef.sampleId) as Array<BrutusCaseRunRelation>
                  const rowSpan = Math.max(1, rels?.length ?? 0)
  
                  return <React.Fragment key={`ref_${curRef.sampleId}_${curRef.name}`}>
                    <tr>
                      <TableCell width={1} rowSpan={rowSpan}>
                        <GenderSelectorSelect name='gender' readOnly showIcon={false} showLabel
                          value={curRef.gender == BrutusJobGender.Male ? SampleSex.Male : SampleSex.Female}
                          onChange={(ev, value) => {
                          }} />
                      </TableCell>
                      <TableCell rowSpan={rowSpan}>
                        {curRef.name}
                      </TableCell>
                      <TableCell rowSpan={rowSpan}>
                        {yesNo(!curRef.isUntested)}
                      </TableCell>
                      <TableCell rowSpan={rowSpan}>
                        {/* {curRef.uploadTime != null ? toDate(new Date(curRef.uploadTime.seconds * 1000 + Math.round(curRef.uploadTime.nanos / 1e6))) : ""} */}
                        {curRef.uploadTime != null ? toDate(curRef.uploadTime) : ""}
                        {/* {curRef.uploadTime.nanos},{curRef.uploadTime.seconds} */}
                      </TableCell>
                      <TableCell>
                        {rels?.map(r => {
                          return props.references.find(x => x.sampleId == r.descendantId)?.name
                        }).find(x => true)}
                      </TableCell>
                      <TableCell>
                        {rels?.filter((x, i) => i == 0).map(r => {
                          return r.isQuestioned ? t.brutus.questioned : t.brutus.assumedTrue
                        }).find(x => true)}
                      </TableCell>
                      {/* {isUhr &&
                      <TableCell width={2} textAlign="center">
                        <BPCheckbox type={'checkbox'} checked={curRef.isMissing} onChange={(ev, d) => {
                        }}></BPCheckbox>
                      </TableCell>
                    } */}
                    </tr>
                    {
                      rels?.map((r, idx2) => {
                        return { id: `${idx2}${r.ancestorId}${r.descendantId}`, name: props.references.find(x => x.sampleId == r.descendantId)?.name, isQuestioned: r.isQuestioned }
                      }).filter((x, i) => i > 0).map(m => (
                        <tr key={m.id}>
                          {/* <td></td> */}
                          {/* <td></td> */}
                          {/* <td></td> */}
                          <td>{m.name}</td>
                          <td>{m.isQuestioned ? t.brutus.questioned : t.brutus.assumedTrue}</td>
                        </tr>
                      ))
                    }
                  </React.Fragment>
                })}
              </tbody>
            </table>
  
            <p style={{ textAlign: 'center' }}>
              <img src={hypDefBase64 as any}></img>
            </p>
            <div>
              {props.details != null &&
                <NoteTemplates textOnly reportType={LabReportsTextsType.Brutus} caseId={props.details?.efmCaseId ?? 0} caseRunId={props.details?.caseRunId ?? 0} labId={props.details?.labId ?? 0} />
              }
            </div>
            <div>
              <table className="brutus center">
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell>{t.common.system}</TableHeaderCell>
                    {testedReferences?.map(ref => (
                      <TableHeaderCell key={`hc_${nanoid(3)}`}>
                        {ref.name}
                      </TableHeaderCell>
                    ))}
                    <TableHeaderCell width={2}>RI</TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {props.model?.systems.map(sys => {
                    return <TableRow key={`risys_${sys.systemName}`}>
                      <TableCell>
                        {sys.systemName}
                      </TableCell>
                      {testedReferences?.map(ref => (
                        <TableCell key={`riref_${nanoid(3)}`}>
                          {ref.systems?.filter(s => s.systemName == sys.systemName)?.map(x => uniqBy(x.alleles.map(a => a.value), a => a).join(','))}
                        </TableCell>
                      ))}
                      <TableCell>{toSci(sys.totalProbability, 4, '0')}</TableCell>
                    </TableRow>
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={1 + testedReferences.length + 1}>
                      {t.brutus.combRelIndex} = {toSci(props.details?.results.result.totalProbability, 4, '0')}
                      <br />
                      {t.caseRunView.probability} (w={props.details?.priorProbabilityInPercent}) = {props.details?.probabilityInPercent}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </table>
            </div>
            <h3>{t.brutus.pedigreeH1} ({t.caseRunView.likelihood} {toSci(props.details?.results.result.H1Probability, 4, '0')})</h3>
            <p style={{ textAlign: 'center' }}>
              <img src={h1Base64}></img>
            </p>
            <h3>{t.brutus.pedigreeH2} ({t.caseRunView.likelihood} {toSci(props.details?.results.result.H2Probability, 4, '0')})</h3>
            <p style={{ textAlign: 'center' }}>
              <img src={h2Base64}></img>
            </p>
          </div>
        </GridColumn>
      </GridRow>
  
      {(!h1Base64) && <GridRow>
        <GridColumn>
          <BPBoxWithHeader header={t.brutus.pedigreeH1}>
            <PedigreeGraph
              onPng={(content) => { setH1Base64(content) }}
              readOnly={true}
              people={props.details?.results.h1.references.map(x => {
                return {
                  displayName: x.name,
                  imported: !x.isUntested,
                  missing: false,
                  personId: x.id.toString(),
                  sex: x.gender == BrutusJobGender.Male ? "M" : "F",
                  sampleName: x.name,
                  systems: []
                }
              }) ?? []}
              relations={props.details?.results.h1.relations.map(x => {
                return {
                  relationId: `h1a${x.ancestorId}d${x.descendantId}`,
                  ancestor: x.ancestorId.toString(),
                  descendant: x.descendantId.toString(),
                  questioned: false
                }
              }) ?? []}></PedigreeGraph>
          </BPBoxWithHeader>
        </GridColumn>
      </GridRow>}
  
      {(!h2Base64) && <GridRow>
        <GridColumn>
          <BPBoxWithHeader header={t.brutus.pedigreeH2}>
            <PedigreeGraph
              onPng={(content) => { setH2Base64(content) }}
              readOnly={true}
              people={props.details?.results.h2.references.map(x => {
                return {
                  displayName: x.name,
                  imported: !x.isUntested,
                  missing: false,
                  personId: x.id.toString(),
                  sex: x.gender == BrutusJobGender.Male ? "M" : "F",
                  sampleName: x.name,
                  systems: []
                }
              }) ?? []}
              relations={props.details?.results.h2.relations.map(x => {
                return {
                  relationId: `h2a${x.ancestorId}d${x.descendantId}`,
                  ancestor: x.ancestorId.toString(),
                  descendant: x.descendantId.toString(),
                  questioned: false
                }
              }) ?? []}></PedigreeGraph>
          </BPBoxWithHeader>
        </GridColumn>
      </GridRow>}
  
      {!hypDefBase64 && <GridRow>
        <GridColumn>
          <PedigreeGraph
            onPng={(content) => {
              setHypDefBase64(content)
            }}
            readOnly
            people={brutusModel?.references?.map(x => {
              return {
                displayName: x.name,
                imported: !x.isUntested,
                missing: x.isMissing,
                personId: x.sampleId.toString(),
                sex: x.gender == BrutusGender.Male ? "M" : "F",
                sampleName: x.name,
                systems: []
              }
            }) ?? []}
            relations={brutusModel?.relations?.map(x => {
              return {
                relationId: `defhypa${x.ancestorId}d${x.descendantId}`,
                ancestor: x.ancestorId.toString(),
                descendant: x.descendantId.toString(),
                questioned: x.isQuestioned
              }
            }) ?? []} />
        </GridColumn>
      </GridRow>}
  
    </Grid>;
  };